import { AxiosError, AxiosResponse } from "axios";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { ReactComponent as PDFImage } from "../../images/MessageCenter/pdf.svg";
import { ReactComponent as PDFWhiteImage } from "../../images/MessageCenter/pdf-white.svg";
import { ReactComponent as DocSaveIcon } from "../../images/MessageCenter/doc-save.svg";
import { ReactComponent as GreenCheckMark } from "../../images/MessageCenter/check-green.svg";
import { BankUserContext } from "../../bankUserContext";
import { toast } from "react-toastify";
import SaveDocumentModal from "./SaveDocumentModal";
import { MessageModel, UserModel } from "../../models/MessageCenterModels";
import Service from "../../services";
import { catchError } from "../../utils/Utils";
import { catchErrorGeneric ,fileFormatSupported} from "../../utils/GeneralUtils";

interface MessageTileProps {
  disableforsuperuser: boolean;
  message: MessageModel;
  setDownloadFile: React.Dispatch<any>;
  setFileLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setViewFile: React.Dispatch<React.SetStateAction<boolean>>;
  users: UserModel[] | [];
}

// const locationsData = [
//   { text: "General", value: "general" },
//   { text: "Organization", value: "organization" },
// ];
const MessageTile = (props: MessageTileProps) => {
  const service = useMemo(() => new Service(), []);
  const { bankuserDetails } = useContext(BankUserContext);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [allClinetsData, setAllClinetsData] = useState<any>([]);
  const [selectedClientId, setSelectedClientId] = useState("");
  const [isSavedDoc, setIsSavedDoc] = useState<boolean>(false);
  const [locationsData, setLocationData] = useState<any>([]);

  const downloadAttachment = () => {
    props.setFileLoading(true);
    if (props?.message?.attachmentPath) {
      service
        .downloadAttachment(props.message.attachmentPath,props.message.fileId)
        .then((res: AxiosResponse<any>) => {
          if (res?.status === 200) {
            if (res?.data) {
              const fileTypeTemp = props?.message?.message.split(".");
              const fileType =
                fileTypeTemp?.length > 2
                  ? fileTypeTemp?.[fileTypeTemp?.length - 1]
                  : fileTypeTemp?.length === 2
                  ? fileTypeTemp?.[1]
                  : "";
                  if(fileFormatSupported(fileType)){
                    props.setDownloadFile({
                      name: props?.message?.message,
                      fileName: props?.message?.message,
                      file: res?.data,
                      fileType: fileType?.toLowerCase(),
                      uri: `${res?.data?.image}`,
                    });
                  }else{
                    toast.error("FileView is not supported");
                  }
              
            }
          } else {
            // toast.error("Something went wrong.");
            catchErrorGeneric("Something went wrong");
            props.setDownloadFile({});
          }
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
          props.setDownloadFile({});
        })
        .finally(() => {
          props.setViewFile(true);
          props.setFileLoading(false);
        });
    }
  };

  const showDocumentHandler = () => {
    // setShowDocumentModal(true);
    // service.getAllORClientIds().then((response: any) => {
    //   const data = response.data.map((element: any) => {
    //     return {
    //       text: `${element.firstName + " " + element.lastName + " - " + element.shortCode}`,
    //       value: element.clientId,
    //     };
    //   });
    //   setAllClinetsData(data);
    // });
    // service
    //   .checkUserRoleMsgThread(props?.message?.createdBy, props?.message?.sentTo)
    //   .then((response: any) => {
    //     if (response.status === 200) {
    //       setSelectedClientId(response.data.clientId ?? "");
    //       response.data.clientId && service.getLocations(response.data.clientId).then((res: any) => {
    //         if (res.status === 200) {
    //           const locData = res.data.map((element: any) => {
    //             return {
    //               text: element,
    //               value: element,
    //             };
    //           });
    //           setLocationData(locData);
    //         }
    //       });
    //     }
    //   });
  };

  const closeSaveDocumentModalHandler = () => {
    setShowDocumentModal(false);
  };

  const onDocSaveHandler = (data: any) => {
    // const body = {
    //   docTitle: data?.docTitle,
    //   location: data?.location,
    //   clientUUID: data?.clientUUID,
    //   filePath: props?.message?.attachmentPath,
    // };
    // service.saveMessageDocument(body).then((response: any) => {
    //   setShowDocumentModal(false);
    //   if (response.status === 202) {
    //     setIsSavedDoc(true);
    //   } else {
    //     toast.error("Something went wrong.");
    //   }
    // });
  };

  const loadLoctionsdata = (clinetId: string) => {
    // clinetId && service.getLocations(clinetId).then((res: any) => {
    //   if (res.status === 200) {
    //     const locData = res.data.map((element: any) => {
    //       return {
    //         text: element,
    //         value: element,
    //       };
    //     });
    //     setLocationData(locData);
    //   }
    // });
  };

  return (
    <>
      {showDocumentModal && (
        <SaveDocumentModal
          showDocumentHandler={showDocumentHandler}
          closeSaveDocumentModalHandler={closeSaveDocumentModalHandler}
          allClinetsData={allClinetsData}
          locationsData={locationsData}
          selectedClientId={selectedClientId}
          onDocSaveHandler={onDocSaveHandler}
          loadLoctions={loadLoctionsdata}
        />
      )}
      <p
        className={`messageTile ${
          props?.message?.createdBy === bankuserDetails?.userId
            ? "self"
            : "sender"
        }`}
      >
        {props?.message?.createdBy !== bankuserDetails?.userId && (
          <span className="senderName">
            {`${props?.message?.userDisplayFirstName || "--"} ${
              props?.message?.userDisplayLastName || "--"
            }`}
          </span>
        )}{" "}
        {props?.message?.messageType === "text" && (
          <span className="messageTileText">{props?.message?.message}</span>
        )}
        {props?.message?.messageType === "attachment" && (
          <>
            <span className="messageTileImage" onClick={downloadAttachment}>
              {props?.message?.createdBy === bankuserDetails?.userId ? (
                <PDFWhiteImage className="pdf-white-image" />
              ) : (
                <PDFImage className="pdf-image" />
              )}{" "}
              {props?.message?.message}
            </span>
            {/* <DocSaveIcon className="doc-save-image"
              onClick={() => showDocumentHandler()}
            />
            {isSavedDoc ? <GreenCheckMark className="checkMark" /> : <></>} */}
          </>
        )}
      </p>
    </>
  );
};

export default MessageTile;
